document.addEventListener('alpine:init', () => {
  Alpine.data('ThemeModule_CartItems', (context) => {
    return {
      context: context,
      itemsRoot: null,
      locked: null,
      items_section: '',
      sections: '',
      init() {
        if (context === 'drawer') {
          this.items_section = 'drawer-cart-items';
          this.sections =
            'drawer-cart-items,drawer-cart-footer,cart-item-count,cart-live-region';
        } else {
          this.items_section = 'cart-items';
          this.sections =
            'cart-items,cart-items,cart-footer,cart-item-count,cart-live-region';
        }

        this.itemsRoot = this.$root;

        window.addEventListener('switch:cart:afteradditem', (e) => {
          Alpine.morph(
            this.itemsRoot,
            querySelectorInHTMLString(
              '[data-cart-items]',
              e.detail.response.sections[this.items_section]
            ).outerHTML
          );
          this.$nextTick(() => {
            document.body.dispatchEvent(new CustomEvent('switch:load:images', { bubbles: true }));
          });
        });

        window.addEventListener('switch:modalcart:cartqtychange', (e) => {
          if (!this.itemsRoot.contains(e.detail.originalTarget)) return;

          Alpine.morph(
            this.itemsRoot,
            querySelectorInHTMLString(
              '[data-cart-items]',
              e.detail.response.sections[this.items_section]
            ).outerHTML
          );

          this.$nextTick(() => {
            document.body.dispatchEvent(new CustomEvent('switch:load:images', { bubbles: true }));
            this.itemsRoot.querySelectorAll('input').forEach((inputEl) => {
              inputEl.value = inputEl.getAttribute('value');
            });
          });

          const liveRegionText = parseDOMFromString(
            e.detail.response.sections['cart-live-region']
          ).firstElementChild.textContent;

          const cartStatus = document.getElementById('cart-live-region-text');

          cartStatus.textContent = liveRegionText;

          cartStatus.setAttribute('aria-hidden', false);

          setTimeout(() => {
            cartStatus.setAttribute('aria-hidden', true);
          }, 1000);

          if (e.detail.originalTarget) {
            this.$nextTick(() => {
              if (!this.itemsRoot.contains(e.detail.originalTarget)) {
                let focusRoot;

                if (this.itemsRoot.closest('[role="dialog"]')) {
                  focusRoot =
                    this.itemsRoot.closest('[role="dialog"]').parentNode;
                } else {
                  focusRoot = this.itemsRoot;
                }

                this.$focus.within(focusRoot).first();
              }
            });
          }
        });
      },
      itemQuantityChange(key, value) {
        if (this.locked) return;

        const lineItemEl = this.$el.closest('li[data-cart-item-key]');
        const id = key ? key : lineItemEl.getAttribute('data-cart-item-key'),
          quantity = parseInt(!isNaN(value) ? value : this.$el.value, 10);

        const config = fetchConfigDefaults();
        config.headers.Accept = 'application/javascript';
        config.body = JSON.stringify({
          id,
          quantity,
          sections: this.sections,
          sections_url: window.location.pathname,
        });

        const lastValue = parseInt(this.$el.dataset.lastValue, 10);

        if (quantity !== lastValue) {
          lineItemEl.classList.add('opacity-50', 'cursor-progress');
          this.locked = lineItemEl;

          fetch(theme.routes.cart_change_url, config)
            .then((res) => {
              if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);
              return res.json();
            })
            .then((data) => {
              if (data.status === 422) {
                const errorEl = lineItemEl.querySelector('[data-cart-quantity-error]');
                errorEl.textContent = data.message;
                errorEl.classList.remove('hidden');
                lineItemEl.classList.remove('opacity-50', 'cursor-progress');
                this.$el.value = lastValue;
                this.$el.dispatchEvent(new Event('input'));
              } else {
                document.body.dispatchEvent(new CustomEvent('switch:modalcart:cartqtychange', {
                  bubbles: true,
                  detail: { response: data, originalTarget: lineItemEl },
                }));
              }
            })
            .catch((error) => {
              console.error('Cart update error:', error);
              lineItemEl.classList.remove('opacity-50', 'cursor-progress');
              this.$el.value = lastValue;
              this.$el.dispatchEvent(new Event('input'));
              const cartErrorsEl = document.getElementById('cart-errors');
              if (cartErrorsEl) {
                cartErrorsEl.textContent = theme.strings.cartError || 'Unable to update cart. Please try again.';
              }
            })
            .finally(() => {
              this.locked = null;
            });
        }
      },
      removeItem(key) {
        this.itemQuantityChange(key, 0);
      },
      _adjustQty(el, operation) {
        if (el?.style?.pointerEvents === 'none') {
          el.style.pointerEvents = 'auto';
        }

        const inputEl = el.closest('li[data-cart-item-key]')?.querySelector('input[type="number"]');

        if (!inputEl) {
          console.error('Input element not found for cart item quantity adjustment.');
          this.showErrorNotification('Error updating item quantity. Please try again.');
          return;
        }

        const lastValue = parseInt(inputEl.dataset.lastValue, 10);
        let newValue = lastValue;

        if (operation === 'increment') newValue = lastValue + 1;
        if (operation === 'decrement') newValue = lastValue > 1 ? lastValue - 1 : 1;
        if (operation === 'remove') newValue = 0;

        inputEl.value = newValue;
        inputEl.dispatchEvent(new Event('change', { bubbles: true }));
      },
      increment() {
        this._adjustQty(this.$el, 'increment');
      },
      decrement() {
        this._adjustQty(this.$el, 'decrement');
      },
      remove() {
        this.$el.style.pointerEvents = 'auto';
        this._adjustQty(this.$el, 'remove');
      },
      showErrorNotification(message) {
        const notification = document.createElement('div');
        notification.className = 'cart-error-notification';
        notification.innerHTML = `
          <div class="notification-content">
            <span class="notification-message">${message}</span>
            <button class="notification-close" aria-label="Close">×</button>
          </div>
        `;
        if (!document.getElementById('cart-notification-styles')) {
          const styles = document.createElement('style');
          styles.id = 'cart-notification-styles';
          styles.textContent = `
            .cart-error-notification {
              position: fixed;
              top: 20px;
              right: 20px;
              background: #fff;
              border: 1px solid #e5e5e5;
              border-left: 4px solid #dc3545;
              border-radius: 4px;
              box-shadow: 0 2px 8px rgba(0,0,0,0.1);
              z-index: 1000;
              max-width: 300px;
              animation: slideIn 0.3s ease;
            }
            .notification-content {
              padding: 16px;
              display: flex;
              align-items: center;
              justify-content: space-between;
              gap: 12px;
            }
            .notification-message {
              font-size: 14px;
              color: #333;
            }
            .notification-close {
              background: none;
              border: none;
              font-size: 18px;
              cursor: pointer;
              color: #999;
              padding: 0;
              line-height: 1;
            }
            @keyframes slideIn {
              from { transform: translateX(100%); opacity: 0; }
              to { transform: translateX(0); opacity: 1; }
            }
          `;
          document.head.appendChild(styles);
        }
        document.body.appendChild(notification);
        setTimeout(() => {
          notification.remove();
        }, 5000);
        notification.querySelector('.notification-close').addEventListener('click', () => {
          notification.remove();
        });
      }
    };
  });
});